import React, { useState, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { ExportOptions } from '../../export-records-modal/enums/export-options-enum';
import { ExportRecordsModalContainer } from './export-records-container';
import { FulfillmentContext } from '../../../../shipping/fulfillments/context';
import { FiltersContext } from '../../../../filters/context';
import {
  customExportFulfillmentsRequest,
  exportFulfillmentsRequestExtended,
} from '../../../../store/external-fulfillments/external-fulfillments.actions';
import { defaultExportFormat } from '../enums/default-export-format';

const ExportFulfillmentsModalContainer = ({ intl, onClose, onOpen }) => {
  const { selectedFulfillmentIds, totalRecords, orderBy, direction, columnConfiguration, quickSearchTerm } = useContext(FulfillmentContext);
  const { buildApiFilters } = useContext(FiltersContext);
  const dispatch = useDispatch();
  const [fulfillmentExportType, setFulfillmentExportType] = useState(ExportOptions.FULFILLMENT);
  const recordExportType = ExportOptions.FULFILLMENT_RECORD_EXPORT;

  const updateFulfillmentExportType = useCallback(
    (primaryRecordsOrLineItems) => {
      if (primaryRecordsOrLineItems === ExportOptions.EXPORT_PRIMARY_RECORDS) {
        setFulfillmentExportType(ExportOptions.FULFILLMENT);
        return;
      }
      setFulfillmentExportType(ExportOptions.FULFILLMENT_LINE_ITEM);
    },
    [setFulfillmentExportType],
  );

  const onExport = useCallback(
    (viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, selectedExportFormatTypeId) => {
      const selectedIds = viewRecordsOrSelectedRecords === ExportOptions.EXPORT_SELECTED_RECORDS ? selectedFulfillmentIds : undefined;
      const filters = viewRecordsOrSelectedRecords === ExportOptions.EXPORT_SELECTED_RECORDS ? undefined : buildApiFilters();
      if (selectedExportFormatTypeId === defaultExportFormat.extractId) {
        dispatch(
          exportFulfillmentsRequestExtended(
            viewRecordsOrSelectedRecords,
            primaryRecordsOrLineItems,
            selectedIds,
            orderBy,
            direction,
            columnConfiguration,
            quickSearchTerm,
            intl,
            filters,
          ),
        );
        onClose();
        return;
      }
      dispatch(
        customExportFulfillmentsRequest(
          viewRecordsOrSelectedRecords,
          selectedExportFormatTypeId,
          selectedIds,
          orderBy,
          direction,
          quickSearchTerm,
          filters,
        ),
      );
      onClose();
    },
    [selectedFulfillmentIds, buildApiFilters, orderBy, direction, columnConfiguration, quickSearchTerm, intl, dispatch, onClose],
  );

  return (
    <ExportRecordsModalContainer
      exportTypeEnum={fulfillmentExportType}
      numberRecordsInView={totalRecords}
      numberRecordsSelected={selectedFulfillmentIds.length}
      onClose={onClose}
      onExport={onExport}
      onUpdateExportType={updateFulfillmentExportType}
      recordExportType={recordExportType}
      retryAction={onOpen}
    />
  );
};

ExportFulfillmentsModalContainer.propTypes = {
  intl: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export const ExportFulfillmentsContainer = injectIntl(ExportFulfillmentsModalContainer);
